<template>
  <CompactHero>
    <template #heading> Vendors </template>
  </CompactHero>

  <div class="row">
    <div class="col-11 col-lg-10 mx-auto">
      <VendorList></VendorList>
    </div>
  </div>
</template>

<script>
import VendorList from "../../components-v2/vendors/VendorList.vue";
import CompactHero from "../../components/ui/hero-banners/CompactHero.vue";

export default {
  name: "ViewVendors",
  components: {
    CompactHero,
    VendorList,
  },
};
</script>

<style scoped></style>
